class WishlistCustomTextTranslation extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.container = document.querySelector('.sn_wishlist');

    this.activeTranslations = true; // Enable or disable translations of wishlist messages

    this.container?.classList.add('__wait');

    // Messages
    this.loginCt;
    this.emptyCt;
    this.loginSelector = '.zwishmsgs .zmsg';
    this.emptySelector = '#ZoomyWishlistPage .zwishemptymsg .zmsg';
    this.hasLogin = false;
    this.hasEmpty = false;

    if(this.activeTranslations) {
      this.loginTrCt = this.element.querySelector('[data-wishlist-translation-login]')?.textContent || '';
      this.loginTrOrCt = this.element.querySelector('[data-wishlist-translation-login-or]')?.textContent || '';
      if(this.loginTrCt != '' && this.loginTrOrCt != '' && this.loginTrCt != this.loginTrOrCt) {
        this.hasLogin = true;
      }

      this.emptyTrCt = this.element.querySelector('[data-wishlist-translation-empty]')?.textContent || '';
      this.emptyTrOrCt = this.element.querySelector('[data-wishlist-translation-empty-or]')?.textContent || '';
      if(this.emptyTrCt != '' && this.emptyTrOrCt != '' && this.emptyTrCt != this.emptyTrOrCt) {
        this.hasEmpty = true;
      }

      if(this.hasLogin || this.hasEmpty) {
        this.waitForElements(this.loginSelector, this.emptySelector, () => {
          this.translateMessages();
        });
        setTimeout(() => {
          this.container?.classList.remove('__wait');
        }, 500);
      }
      else {
        this.container?.classList.remove('__wait');
      }
    }
    else {
      this.container?.classList.remove('__wait');
    }
  }

  waitForElements(selector1, selector2, callback) {
    const el1 = document.querySelector(selector1);
    if (el1) {
      callback(el1, selector1);
      return;
    }

    const el2 = document.querySelector(selector2);
    if (el2) {
      callback(el2, selector2);
      return;
    }

    const observer = new MutationObserver(() => {
      const found1 = document.querySelector(selector1);
      if (found1) {
        observer.disconnect();
        callback(found1, selector1);
        return;
      }

      const found2 = document.querySelector(selector2);
      if (found2) {
        observer.disconnect();
        callback(found2, selector2);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  translateMessages() {
    let loginMessage = '';
    if(this.hasLogin) {
      this.loginCt = document.querySelector(this.loginSelector);
      loginMessage = this.loginCt?.textContent || '';
      if(loginMessage == this.loginTrOrCt) {
        this.loginCt.textContent = this.loginTrCt;
      }
    }
    let emptyMessage = '';
    if(this.hasEmpty) {
      this.emptyCt = document.querySelector(this.emptySelector);
      emptyMessage = this.emptyCt?.textContent || '';
      if(emptyMessage == this.emptyTrOrCt) {
        this.emptyCt.textContent = this.emptyTrCt;
      }
    }
    this.container?.classList.remove('__wait');
  }
}

customElements.define("wishlist-custom-text-translation", WishlistCustomTextTranslation);
